<template>
    <div :class="cmp_class">
        <div class="d-flex justify-space-between">
          <div>
              <small class="mr-2"><i class="grey--text">{{notification.rank}}</i></small>
            <v-icon>{{ notification.icon }}</v-icon>
            <b class="ml-2">{{ notification.title }}</b>
          </div>
          <div>
            <small
              ><b>{{ notification.date_posted }}</b>  </small
            >
          </div>
        </div>
        <div class="text-left pb-2 pt-2">
          {{ notification.message }}
        </div>
        <div class="text-left d-flex justify-space-between ">
          <small>#{{ notification.message_identity }}</small>
          <a :href="notification.deep_link">{{ notification.deep_link }}</a>
        </div>
    </div>
</template>

<script>
export default {
  name: "NotificationItem",
  props: {
    notification: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  computed: {
    cmp_class() {
      var str =
        "d-flex flex-column justify-space-between bb-1-dotted  pa-2 mt-2 mb-2 ";
      if (this.notification && this.notification != null) {
        if (parseInt(this.notification.is_read) == 0) {
          str = str + " error lighten-5";
        } else {
          str = str + " ";
        }
      }
      return str;
    },
  },
};
</script>